function getProductBadgesData(productURL) {
  const storeId = GetSelectedStoreId();
  const baseProductURL = productURL.split("?")[0];
  const url = baseProductURL + '?view=badgesajax&store_id='+ storeId + '&type=' + GetRandomInt(1,100) + '&cache=false&quantity='+ GetRandomInt(1,100);
  return fetch(url).then(function (response) {
    return response.text().then(function (content) {
      const badgesData = JSON.parse(content);
      return badgesData;
    }).catch((err) => {
      console.log(`getProductBadgesData url: ${url} - response failed`, err);
    });
  }).catch((err) => {
    console.log(`getProductBadgesData url: ${url} - failed to fetch`, err);
  });
}

function addLinkParentElement(targetElement, link) {
  const loadedClass = 'link-added';
  if(targetElement && !targetElement.classList.contains(loadedClass)) {
    targetElement.classList.add(loadedClass);
    const parentElement = targetElement.parentNode;
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', link);
    linkElement.classList.add(...targetElement.classList);
    parentElement.removeChild(targetElement);
    linkElement.appendChild(targetElement);
    parentElement.appendChild(linkElement);
  }
}

function addLinkToReviews(itemContainerElement, link) {
  const positionedClass = 'reviews_positioned';
  const reviewsContainerElement = itemContainerElement.querySelector('.reviews-container');
  if(reviewsContainerElement && !reviewsContainerElement.classList.contains(positionedClass)) {
    reviewsContainerElement.classList.add(positionedClass);
    addLinkParentElement(reviewsContainerElement, link);
  }
}

function addLinkToPrice(itemContainerElement, link, comparePrice) {
  const priceContainerElement = itemContainerElement.querySelector('.price-container');
  if(comparePrice > 0) {
    const priceElement = priceContainerElement.querySelector('.price');
    priceElement.classList.add('regular-price');
  }
  addLinkParentElement(priceContainerElement, link);
}

function loadDiscountLabel(infoContainerElement, data) {
  const discountLabelClass = 'fs-product-discount';
  let labelElement = infoContainerElement.querySelector(`.${discountLabelClass}`);

  if(!labelElement
    && parseFloat(data.comparePrice) > 0
    && parseFloat(data.comparePrice) > parseFloat(data.price)) {
    const save = Math.floor(data.comparePrice - data.price);
    labelElement = document.createElement('span');
    labelElement.classList.add(discountLabelClass, fsCustomElementClass);
    labelElement.textContent = `(Save $${save})`;
    infoContainerElement.insertAdjacentElement('beforeend', labelElement);
  }
}

function loadSaleBadgePLP(data, itemContainerElement) {
  const attributes = data.attributes;
  const isOnSale = attributes.some(values => values[0] === 'Tag' && values[1].includes(fsOnSaleFilterTag));
  const saleClass = 'on-sale';
  const saleBadgeElement = itemContainerElement.querySelector(`.${saleClass}`); /* this refers to if the badge exists currently */

  if(!saleBadgeElement && isOnSale) {
    const spanElement = document.createElement('span');
    spanElement.classList.add('fs-custom-badge', saleClass, fsCustomElementClass, 'xxxxxxxx');
    itemContainerElement.prepend(spanElement);
  }
}

function loadSaleEndsDate(badgesResponse, infoContainerElement) {
  const isSaleEndsDateEnabled = false;
  const saleEndsDate = badgesResponse.sale_end_date;
  const saleEndsDateDisplay = badgesResponse.sale_end_date_display;
  const saleEndsLoadedClass = 'fs-plp-sale-ends-date';
  const saleEndsPlaceholderClass = 'fs-plp-sale-ends-date-placeholder';
  const saleEndsElement = infoContainerElement.querySelector(`.${saleEndsLoadedClass}`);

  if (!saleEndsElement && isSaleEndsDateEnabled ) {
    const saleEndsDateElement = document.createElement('span');
    if(!!saleEndsDate) {
      const generalSaleEndsText = 'Saving Ends:';
      const formattedSaleEndsDate = new Date(saleEndsDate);
      const formattedCurrentDate = new Date();
      const hoursBetweenDates = GetHoursDifference(formattedCurrentDate, formattedSaleEndsDate);
      saleEndsDateElement.classList.add(saleEndsLoadedClass, fsCustomElementClass);
      let saleEndsDateContent = generalSaleEndsText;
      if(hoursBetweenDates > 24 && hoursBetweenDates < 48) {
        const saleEndsTomorrowText = 'Tomorrow';
        saleEndsDateContent += ` ${saleEndsTomorrowText}`;
      } else if (hoursBetweenDates > 0 && hoursBetweenDates <= 24) {
        const saleEndsTodayText = 'Today';
        saleEndsDateContent += ` ${saleEndsTodayText}`;
      } else {
        saleEndsDateContent += ` ${saleEndsDateDisplay}`;
      }
      saleEndsDateElement.textContent = saleEndsDateContent;
    } else {
      saleEndsDateElement.classList.add(saleEndsLoadedClass, saleEndsPlaceholderClass, fsCustomElementClass);
      saleEndsDateElement.textContent = '&nbsp';
      saleEndsDateElement.style.visibility = "hidden";
    }
    infoContainerElement.insertAdjacentElement('beforeend', saleEndsDateElement);
  }
}

function fsLoadInStockBadge(badgesResponse, badgeContainerElement) {
  const inStockBadgeClass = 'badge--instock-label-plp';
  let inStockBadgeElement = badgeContainerElement.querySelector(`.${inStockBadgeClass}`);

  if(!inStockBadgeElement) {
    /** Load inStock Badge if it is not loaded -- plp**/
    const inStock = badgesResponse.instock;
    const inStockCanadaWide = badgesResponse.instock_canada_wide;
    inStockBadgeElement = document.createElement('span');
    inStockBadgeElement.classList.add(inStockBadgeClass);
    inStockBadgeElement.textContent = 'In stock';

    if (inStock || inStockCanadaWide) { /* case where inStock or inStockCanadaWide, we either tag it instock-canada-wide or instock which will show the element */
      const inStockBadgeTrackingClass = inStockCanadaWide ? 'instock-canada-wide' : 'instock'; /* these classes are placeholders for tracking, there is no styling on it. */
    inStockBadgeElement.classList.add(inStockBadgeTrackingClass);
      badgeContainerElement.insertAdjacentElement('afterbegin', inStockBadgeElement); /* we only add the in stock element if it is in stock */
    }
  }
}

function fsLoadNextDayDeliveryAndCoastRecommendsBadge(badgesResponse, itemContainerElement) {
  const inStockLocationArray = badgesResponse.in_stock_location_list;
  //build right corner badge parent element
  const rightCornerBadgeParentLoadedClass = 'fs-right-corner-badge-parent';
  const rightCornerBadgeParent = document.createElement('div');
  rightCornerBadgeParent.classList.add(rightCornerBadgeParentLoadedClass, fsCustomElementClass);

  //handle next day badge
  const nextDayDeliveryLoadedClass = 'fs-next-day-delivery-badge';
  const shouldRenderNextDayDeliveryBadge = shouldShowNextDay(inStockLocationArray);
  let nextDayDeliveryElement = itemContainerElement.querySelector(`.${nextDayDeliveryLoadedClass}`);
  if(shouldRenderNextDayDeliveryBadge) {
    nextDayDeliveryElement = document.createElement('img');
    nextDayDeliveryElement.classList.add(nextDayDeliveryLoadedClass, fsCustomElementClass);
    nextDayDeliveryElement.src = '//www.coastappliances.ca/cdn/shop/t/2715/assets/24h-delivery-icon.svg?v=56484830790926027761782509721';
    rightCornerBadgeParent.appendChild(nextDayDeliveryElement);
  }

  //handle coast recommends badge
  const coastRecommendsLoadedClass = 'fs-coast-recommends-badge';
  let coastRecommendsElement = itemContainerElement.querySelector(`.${coastRecommendsLoadedClass}`);
  let shouldRenderCoastRecommendsBadge = false;
  if(badgesResponse['coast_recommends']){
    shouldRenderCoastRecommendsBadge = true;
  }
  if(shouldRenderCoastRecommendsBadge) {
    const productCardElement = itemContainerElement.querySelector('.product-card-items-wrapper');
    coastRecommendsElement = document.createElement('img');
    coastRecommendsElement.classList.add(coastRecommendsLoadedClass, fsCustomElementClass);
    coastRecommendsElement.src = '//www.coastappliances.ca/cdn/shop/t/2715/assets/coast-recommends-badge.svg?v=55089324371072128681782509721';
    rightCornerBadgeParent.appendChild(coastRecommendsElement);
  }

  //insert parent element
  if(!itemContainerElement.querySelector(`.${rightCornerBadgeParentLoadedClass}`)){
    const productCardElement = itemContainerElement.querySelector('.product-card-items-wrapper');
    productCardElement?.insertAdjacentElement('beforebegin', rightCornerBadgeParent);
  }
}

function removeSpecialCharacters(str) {
    const regex = /[^a-zA-Z0-9-_]/g; // Include hyphens and underscores as allowed characters
    return str.replace(regex, '');
}

function sortByPriority(a, b) {
  return a.badgePriority - b.badgePriority;
}

function fsLoadPromoBadges(badgeContainerElement, promoBadgesClasses, dataProductId) {
  let itemcss = '';
  const badgePlaceHolderElement = document.createElement('span');
  badgePlaceHolderElement.classList.add('item-no-badge-placeholder');
  let badgeElementArray = [];
  if(promoBadgesClasses.length > 0) {
    for(const badgeClass of promoBadgesClasses) {
      const tagReference = badgeClass.replaceAll('::', ' '); /* we only use the tagRefence to find the badge from the global productBadgeTags variable*/
      const badge = productBadgeTags.find(badgeData => badgeData.tag === tagReference);
      if(badge) {
        const isLinkEnabled = badge.is_link_enabled;
        const linkUrl = badge.url;
        const tagName = removeSpecialCharacters(badge.tag).replaceAll(' ', '::');/* here we're setting the tagName to be used */
        const badgeContent = badge.badge_content;
        const badgePriority = parseInt(badge.priority);
        const badgeClassName = tagName.toLowerCase();
        if(!badgeContainerElement.classList.contains('badge-hide-overflow')
           && (badge.style == 'pdp_badge_style_tgr' || badge.style == 'pdp_badge_style_tgl')) {
          badgeContainerElement.classList.add('badge-hide-overflow');
        }

        if(badgeContainerElement.querySelectorAll(`.${badgeClassName}`).length === 0) {
          let textContent = '';
          let styleElement = document.createElement('style');
          const badgeElement = document.createElement('span');
          badgeElement.classList.add(badgeClassName, 'badge--promo-plp', `fs-${badge.style}-plp`);
          badgeElement.setAttribute("badge-priority", badgePriority);
          if (badge.style == 'pdp_badge_style_tgr') {
            textContent = `[data-product-id='${dataProductId}'] .${badgeClassName}.fs-${badge.style}-plp::after { border-left: 13px solid ${badge.background_color}; } [data-product-id='${dataProductId}'] .${badgeClassName}.fs-${badge.style}-plp::before { background: ${badge.text_color}; }`;
          }
          if (badge.style == 'pdp_badge_style_tgl') {
            textContent = `[data-product-id='${dataProductId}'] .${badgeClassName}.fs-${badge.style}-plp::before { border-right: 13px solid ${badge.background_color}; } [data-product-id='${dataProductId}'] .${badgeClassName}.fs-${badge.style}-plp::after { background: ${badge.text_color}; }`;

          }

          if(textContent) {
            styleElement.textContent = textContent;
            badgeContainerElement.parentNode.insertBefore(styleElement, badgeContainerElement.nextSibling);
          }

          badgeElement.style.color = badge.text_color;
          badgeElement.style.background = badge.background_color;
          badgeElement.textContent = badgeContent;
          badgeElementArray.push({ badgePriority: badgePriority, isLinkEnabled: isLinkEnabled, linkUrl: linkUrl, badgeElement: badgeElement });
        }
      }
    }
    badgeElementArray.sort(sortByPriority);
    badgeElementArray.forEach((item) => {
        let targetBadgeElement = item.badgeElement;
        if(item.isLinkEnabled && item.linkUrl.length > 0) {
            const linkElement = document.createElement('a');
            linkElement.setAttribute('href', item.linkUrl);
            linkElement.appendChild(item.badgeElement);
            targetBadgeElement = linkElement;
          }
      badgeContainerElement.appendChild(targetBadgeElement);
    })
  } else {
    badgeContainerElement.appendChild(badgePlaceHolderElement);/* adding a placeholder to keep dom consistent */
  }
}


function loadReviewPlaceholder(infoContainerElement) {
  const emptyReview = infoContainerElement.querySelector('[title="Be the first to review this product"]');
  if(emptyReview){
    emptyReview.textContent = '&nbsp';
    emptyReview.style.visibility = 'hidden';
  }
}

//Load Clearance Model Available - plp  called in coast-product.js.liquid
async function fsLoadClearanceModelAvailablePLP(itemContainerElement, infoContainerElement, clearanceValues, salePrice) {
  const isClearanceEnabled = true;
  const clearanceModelAvailableClass = 'plp-clearance-model-available';
  let clearanceModelAvailableElement = itemContainerElement.querySelector(`.${clearanceModelAvailableClass}`);

  if(!clearanceModelAvailableElement && isClearanceEnabled && clearanceValues) {
    const currentRegion = await GetSelectedStoreRegion();
    const regionQOH = await calculateQOHByRegion(currentRegion, clearanceValues);
    const clearanceModelText = await getClearanceModelAvailableText(currentRegion, clearanceValues, false, salePrice); //we actually pass salePrice as a back up if the clearanceValues has no regional min price
    if(regionQOH > 0) {
      clearanceModelAvailableElement = document.createElement('div');
      clearanceModelAvailableElement.classList.add(clearanceModelAvailableClass, fsCustomElementClass);
      clearanceModelAvailableElement.innerHTML = clearanceModelText; /* we use innerHTML because clearanceModelText could have <b> tags */
      infoContainerElement.insertAdjacentElement('afterend', clearanceModelAvailableElement);
    }
  }
}

function removeCustomElements(itemContainerElement) {
  const customElements = itemContainerElement.querySelectorAll(`.${fsCustomElementClass}`);
  customElements.forEach(e => e.remove());
}

function setProductsGridClass(productsGridElement) {
  const currentQueryFiltersString = getFiltersQueryString();
  /* when the removable tags are shown on mobile we need to add a class to products grid, we determine if this is needed by screen size and if the url has filters */
  if(window.innerWidth <= 559 && currentQueryFiltersString) {
    productsGridElement.classList.add('products-grid-with-tags-mobile');
  } else if (productsGridElement.classList.contains('products-grid-with-tags-mobile')) {
    productsGridElement.classList.remove('products-grid-with-tags-mobile')
  }
}

function fsProductGridOrchestrator(productURL, itemContainerElement, data) {
  const itemContainerProductId = itemContainerElement.getAttribute('data-product-id');
  const dataProductId = data.id;
  const loadedClassPartial = 'coast-loaded-product-';
  const loadedClass = `${loadedClassPartial}${dataProductId}`;
  const itemContainerClassArray = Array.from(itemContainerElement.classList);
  const oldLoadedClass = itemContainerClassArray.find(itemContainerClass => itemContainerClass.includes(loadedClassPartial) && itemContainerClass !== loadedClass);
  if(oldLoadedClass) {
    itemContainerElement.classList.remove(oldLoadedClass);
    removeCustomElements(itemContainerElement);
  }

  if(oldLoadedClass || (!itemContainerElement.classList.contains(loadedClass) && itemContainerProductId === dataProductId)) {
    const infoContainerElement = itemContainerElement.querySelector('.info-container');
    addLinkToReviews(itemContainerElement, productURL);
    addLinkToPrice(itemContainerElement, productURL, data.comparePrice);
    loadDiscountLabel(infoContainerElement, data);
    loadSaleBadgePLP(data, itemContainerElement);
    loadReviewPlaceholder(infoContainerElement);
    let badgeContainerElement  = itemContainerElement.querySelector('.product-item-badges-container-plp');

    if (!badgeContainerElement) {
      badgeContainerElement = document.createElement('div');
      badgeContainerElement.classList.add('product-item-badges-container-plp', fsCustomElementClass);
      infoContainerElement.insertAdjacentElement('beforebegin', badgeContainerElement);
    }

    getProductBadgesData(productURL).then((badgesData) => {
      loadSaleEndsDate(badgesData, infoContainerElement);
      fsLoadNextDayDeliveryAndCoastRecommendsBadge(badgesData, itemContainerElement);
      fsLoadClearanceModelAvailablePLP(itemContainerElement, infoContainerElement, badgesData.clearance_values, badgesData.sale_price);
      if(badgeContainerElement) {
        fsLoadInStockBadge(badgesData, badgeContainerElement);
        fsLoadPromoBadges(badgeContainerElement, badgesData.plp_badge_classes, dataProductId);
      }
        itemContainerElement.classList.add(loadedClass);
    }).catch((err) => {
      console.log(`fsProductGridOrchestrator promise failed`, err);
    });
  }
}
